module.exports = __webpack_public_path__ + "static/scale-model-of-pedal-power-tours-in-pittsburgh-pennsylvania-d7e62471063622a7d0e23ce4dfbd864e.png";